<template>
    <div class="w-full h-auto relative flex justify-center">
        <img src="../../assets/img/Desktop/ConquerTheVastWorld/backConquer.webp" alt="" class="w-full blur-[1.05vw]">
        <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame6.webp" alt="" class="w-full h-auto absolute top-0">
        <!-- Text1 -->
        <p
            class="font-emeritus text-white text-[3.65vw] absolute top-[7.65625vw] uppercase [text-shadow:0.2vw_0.2vw_#00000025]">
            Conquer the Vast Worlds</p>
        <!-- container -->
        <div class="w-[83vw] h-[28.4375vw] absolute top-[17vw] flex flex-row justify-between">
            <div class="w-[47.08vw] h-[28.4375vw] flex flex-col justify-between items-end">
                <!-- left 1-->
                <div
                    class="w-[47.08vw] h-[13.7vw] relative rounded-[0.6vw] flex justify-center items-hover overflow-hidden">
                    <img src="../../assets/img/Desktop/ConquerTheVastWorld/8.webp" alt="" class="bg-hover">
                    <div class="absolute flex flex-col justify-center bottom-0">
                        <p class="text-center text-white font-emeritus text-[2.33vw] uppercase">campaign stages</p>
                        <p class="text-center text-white font-league text-[1.14vw] font-extralight">Progress through
                            epic story missions and conquer new territories.</p>
                    </div>
                </div>
                <!-- Left-2 -->
                <div class="w-[42.06vw] h-[13.7vw] bg-white relative rounded-[0.6vw] items-hover overflow-hidden">
                    <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame5.webp" alt=""
                        class="bg-hover translate-y-[0.2vw]">
                    <div class="absolute flex flex-col justify-end bottom-0 right-[0.8vw]">
                        <p class="text-end text-white font-emeritus text-[2.33vw] uppercase">Boss Fight</p>
                        <p class="text-end text-white font-league text-[1.14vw] font-extralight">Face mighty enemies and
                            test your team’s true strength.</p>
                    </div>
                </div>
            </div>
            <div
                class="w-[16.5625vw] h-[28.4375vw] relative rounded-[0.6vw] items-hover overflow-hidden flex justify-center">
                <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame1.webp" alt=""
                    class="bg-hover translate-y-[0.2vw]">
                <div class="absolute flex flex-col justify-center top-[0.5vw]">
                    <p class="text-center text-white font-emeritus text-[2.33vw] uppercase">PvP Arena<br />RANKING</p>
                    <p class="text-center text-white font-league text-[1.14vw] font-extralight">Battle other players and
                        rise to the<br /> top of the leaderboard.</p>
                </div>
            </div>
            <div
                class="w-[16.5625vw] h-[28.4375vw] relative rounded-[0.6vw] items-hover overflow-hidden flex justify-center">
                <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame2.webp" alt=""
                    class="bg-hover translate-y-[0.2vw]">
                <div class="absolute flex flex-col justify-center top-[0.6vw]">
                    <p class="text-center text-white font-emeritus text-[2.33vw] uppercase">Final Clash</p>
                    <p class="text-center text-white font-league text-[1.14vw] font-extralight">Confront powerful foes and challenge your team’s real potential.</p>
                </div>
            </div>
        </div>

        <div class="w-[83vw] absolute bottom-0 rounded-[0.6vw] flex justify-center overflow-hidden items-hover">
            <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame3.webp" alt="" class="bg-hover">
            <div class="absolute flex flex-col justify-center bottom-0">
                <p class="text-center text-white font-emeritus text-[2.33vw] uppercase">Join PvE events</p>
                <p class="text-center text-white font-league text-[1.14vw] font-extralight">Take part in limited-time battles and earn valuable rewards.</p>
            </div>
        </div>
        <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame7.webp" alt="" class="absolute w-[21vw] h-auto top-[24.21875vw] left-[3vw]">
    </div>
</template>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.bg-hover{
    scale: 1.05;
    transition: all 0.5s ease-in-out;
}

.items-hover:hover .bg-hover{
    scale: 1.2;
    transition: all 0.5s ease-in-out;
}
</style>